import { AppState } from 'store';

export const getSession = (state: AppState) => state.session;

export const getUser = (state: AppState) => state.session.user;

export const getUserId = (state: AppState) => state.session.user?.id;

export const getUserRole = (state: AppState) => state.session.role;

export const getUserIsLoading = (state: AppState) => state.session.isLoading.user;

export const getInitIsLoading = (state: AppState) => state.session.isLoading.init;
